/* Rorilio · LP Aceite : compte à rebours jusqu'à minuit heure de Mexico, barre de lecture, barre CTA collante après 600 px, vidéos en lecture auto au défilement. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function init() {
    var root = document.querySelector('[data-racl]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    /* Minuit heure de Mexico (UTC-6 fixe), quel que soit le fuseau du visiteur ; repart chaque jour ; barre masquée après la fin de la promo (data-end). */
    var OFF = 6 * 3600000;
    function nextMidnightMx(now) { var mx = new Date(now - OFF); return Date.UTC(mx.getUTCFullYear(), mx.getUTCMonth(), mx.getUTCDate() + 1) + OFF; }
    window.raclNextMidnightMx = nextMidnightMx;
    var end = Date.parse(root.dataset.end || '');
    var h = document.querySelector('[data-racl-h]'), m = document.querySelector('[data-racl-m]'), s = document.querySelector('[data-racl-s]');
    var timer = root.querySelector('.racl-timer');
    function tick() {
      var now = Date.now();
      if (!isNaN(end) && now >= end) { if (timer) timer.style.display = 'none'; return; }
      var target = nextMidnightMx(now); if (!isNaN(end) && end < target) target = end;
      var x = Math.max(0, Math.floor((target - now) / 1000));
      if (h) h.textContent = pad(Math.floor(x / 3600)); if (m) m.textContent = pad(Math.floor((x % 3600) / 60)); if (s) s.textContent = pad(x % 60);
    }
    tick(); setInterval(tick, 1000);
    var sticky = document.querySelector('[data-racl-sticky]'), fill = document.querySelector('[data-racl-fill]');
    function onScroll() {
      var d = document.documentElement, y = window.scrollY || d.scrollTop || 0;
      if (sticky) sticky.classList.toggle('is-on', y > 600);
      if (fill) { var den = (d.scrollHeight - d.clientHeight) || 1; fill.style.width = Math.min(100, Math.max(0, y / den * 100)).toFixed(2) + '%'; }
    }
    window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); onScroll();
    var vids = [].slice.call(document.querySelectorAll('.racl video'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); } else if (v.pause) v.pause(); }); }, { rootMargin: '250px 0px' });
      vids.forEach(function (v) { io.observe(v); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
